import React from 'react';
import { createUseStyles } from 'react-jss';

import { useGame } from '../../../../context';
import Category from './category';

const useStyles = createUseStyles({
  categories: {
    composes: [
      'flex-columns',
      'flex-0',
      'flex-wrap',
      'flex-start',
      'margin-auto',
    ],
    maxWidth: 170,
    minWidth: 170,
    width: 170,
  },
});

const sortByOrder = (a, b) => {
  if (a.order > b.order) return 1;
  if (a.order < b.order) return -1;
  return 0;
};

const CategoriesFilterComponent = React.memo(() => {
  const classes = useStyles();
  const { icons } = useGame();

  return (
    <div className={classes.categories}>
      {Object.values(icons)
        .sort(sortByOrder)
        .map(data => {
          const { id } = data;
          return <Category key={id} data={data} />;
        })}
    </div>
  );
});

CategoriesFilterComponent.displayName = 'CategoriesFilterComponent';

export default CategoriesFilterComponent;
